var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64256 5.17672L10.4764 5.07547L11.1514 5.75048L8.78881 8.11305L11.5001 10.8244V11.4994L10.8251 11.4994L8.11379 8.78807L5.75123 11.1506L5.07621 10.4756L5.10996 8.70932L1.37485 4.97421L0.812334 5.53673L0.137314 4.86171L4.79495 0.204074L5.46997 0.879094L4.90745 1.44161L8.64256 5.17672ZM5.98748 9.56434L9.49758 6.05424L8.21505 6.09924L4.23243 2.11663L2.04987 4.29919L6.03248 8.28181L5.98748 9.56434Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.49c88921482bcd96960a84d0b49cb9f1.svg";
export { ForwardRef as ReactComponent };